"use client"

import { motion, AnimatePresence } from "framer-motion"
import { CheckCircle2 } from "lucide-react"
import { SIEMENS_BLUE } from "@/lib/mprc-config"

interface ProcessStepProps {
  label: string
  isActive: boolean
  stepNumber: number
}

export function ProcessStep({ label, isActive, stepNumber }: ProcessStepProps) {
  return (
    <div
      className={`flex items-center gap-2.5 px-3 py-1.5 transition-all duration-300 border-l-2 ${
        isActive ? "bg-primary/5" : "hover:bg-accent/30 border-l-transparent"
      }`}
      style={isActive ? { borderLeftColor: SIEMENS_BLUE } : {}}
    >
      <span
        className="size-5 rounded-full flex items-center justify-center text-[10px] font-mono font-bold shrink-0 transition-all duration-300"
        style={
          isActive
            ? { background: SIEMENS_BLUE, color: "white" }
            : { background: "rgba(128,128,128,0.15)", color: "rgba(128,128,128,0.55)" }
        }
      >
        {stepNumber}
      </span>

      <span
        className={`flex-1 text-xs leading-tight transition-all duration-300 ${
          isActive ? "text-foreground font-medium" : "text-muted-foreground"
        }`}
      >
        {label}
      </span>

      <AnimatePresence mode="wait" initial={false}>
        {isActive ? (
          <motion.span
            key="active"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <CheckCircle2 className="size-3.5 shrink-0" style={{ color: SIEMENS_BLUE }} />
          </motion.span>
        ) : (
          <motion.span
            key="inactive"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <span className="size-3.5 rounded-full border-2 border-muted-foreground/25 block" />
          </motion.span>
        )}
      </AnimatePresence>
    </div>
  )
}
